/* eslint-disable no-sequences */
import firebase from 'firebase/app'
import 'firebase/firestore'

export const state = {
  user: {
    loggedIn: false,
    data: null,
  },
  testUser: {
    loggedIn: false,
    data: null,
  },
  testInterfaceMessage: '',
  users: [],
  userIds: [],
  // END OF FILTERS
}

export const mutations = {
  // END OF USER VIEW FILTERS
  SET_LOGGED_IN(state, value) {
    state.user.loggedIn = value
  },
  SAVE_USER(state, data) {
    state.user.data = data
  },
  SET_LOGGED_IN_TEST_USER(state, value) {
    state.testUser.loggedIn = value
  },
  SAVE_TEST_USER(state, data) {
    state.testUser.data = data
  },
  SAVE_USERS(state, data) {
    state.users = data
  },
  SAVE_USER_IDS(state, data) {
    state.userIds = data
  },
  SAVE_MESSAGE(state, data) {
    state.testInterfaceMessage = data
  },
}

export const getters = {
  getUser() {
    return state.user
  },
  getUsers() {
    return state.users
  },
  getTestUser() {
    return state.testUser
  },
  getMessage() {
    return state.testInterfaceMessage
  },
}

export const actions = {
  // fetch LOGGED IN USER data
  fetchUser({ commit }, user) {
    commit('SET_LOGGED_IN', user !== null)
    if (user) {
      commit('SAVE_USER', {
        displayName: user.displayName,
        email: user.email,
        photoURL: user.photoURL,
      })
    } else {
      commit('SAVE_USER', null)
    }
  },

  // fetch QA TEST users
  fetchUsers({ commit }, payload) {
    firebase
      .firestore()
      .collection('users')
      .get()
      .then((data) => {
        const users = []
        const userIds = []
        // test exists
        for (const doc in data.docs) {
          const user = data.docs[doc].data()
          user.accessDate = user.accessDate ? user.accessDate.toDate() : null // fix date format
          user.id = data.docs[doc].id // pass firestoreid in object
          users.push(user)
          userIds.push(data.docs[doc].id)
        }
        users.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }))
        commit('SAVE_USERS', users)
        commit('SAVE_USER_IDS', userIds)
      })
      .catch((error) => {
        console.log('Error getting document:', error)
      })
  },

  loginTestUser: ({ commit, rootState, dispatch }, payload) => {
    // save modified test data
    firebase
      .firestore()
      .collection('users')
      .doc(payload.name)
      .get()
      .then((user) => {
        const data = user.data()
        if (data !== undefined) {
          // user exists
          if (data.password === payload.password) {
            // correct password
            const loginTime = new Date()
            if (data.accessDate) {
              // already started a session
              const timeLimit =
                Number(data.accessLimit) * 60000 +
                data.accessDate.toDate().getTime()
              if (loginTime.getTime() > timeLimit) {
                // expired session
                commit('SAVE_MESSAGE', 'Sorry, your time is up!')
                commit('SET_LOGGED_IN_TEST_USER', false)
              } else {
                commit('SAVE_TEST_USER', {
                  name: data.name,
                  candidate: data.candidate,
                  accessLimit: data.accessLimit,
                  accessDate: data.accessDate.toDate(),
                })
                commit('SET_LOGGED_IN_TEST_USER', true)
              }
            } else {
              // update his access time
              const user = {
                name: data.name,
                candidate: data.candidate,
                password: data.password,
                accessLimit: data.accessLimit,
                accessDate: firebase.firestore.Timestamp.fromDate(loginTime),
              }
              firebase
                .firestore()
                .collection('users')
                .doc(data.name)
                .set(user)
                .then(() => {
                  console.log('updated')
                  commit('SAVE_TEST_USER', {
                    name: data.name,
                    candidate: data.candidate,
                    accessLimit: data.accessLimit,
                    accessDate: loginTime,
                  })
                  commit('SET_LOGGED_IN_TEST_USER', true)
                })
                .catch((error) => {
                  console.log('Error getting document:', error)
                })
            }
          } else {
            // wrong password
            commit(
              'SAVE_MESSAGE',
              'Sorry, this user/password combination does not exist.'
            )
            commit('SET_LOGGED_IN_TEST_USER', false)
          }
        } else {
          // user doesn't exist
          commit(
            'SAVE_MESSAGE',
            'Sorry, this user/password combination does not exist.'
          )
          commit('SET_LOGGED_IN_TEST_USER', false)
          commit('SAVE_TEST_USER', null)
        }
      })
      .catch((error) => {
        console.log('Error getting document:', error)
      })
  },

  endSession: ({ commit, rootState, dispatch }, payload) => {
    commit('SAVE_MESSAGE', 'Sorry, your time is up!')
    commit('SET_LOGGED_IN_TEST_USER', false)
    commit('SAVE_TEST_USER', null)
  },

  saveUser: ({ commit, rootState, dispatch }, payload) => {
    // save modified test data
    const user = {
      name: payload.name,
      candidate: payload.candidate,
      password: payload.password,
      accessLimit: payload.accessLimit,
      accessDate: null,
    }
    firebase
      .firestore()
      .collection('users')
      .doc(payload.name)
      .set(user)
      .then(() => {
        console.log('updated')
        // refetch all users after updating
        dispatch('fetchUsers')
      })
      .catch((error) => {
        console.log('Error getting document:', error)
      })
  },
  deleteUser: ({ dispatch }, payload) => {
    firebase
    .firestore()
    .collection('users')
    .doc(payload.name)
    .delete()
    .then(() => {
      console.log(`${payload.name} deleted`)
      // refetch all users after updating
      dispatch('fetchUsers')
    })
    .catch((error) => {
      console.log('Error removing document: ', error)
    })
  }
}
